const listDefaults = {
  props: {
    searchIn: {
      type: String,
      required: false,
      default: ''
    }
  },

  data () {
    return {
      first: true,
      dialog: {
        view: false,
        save: false,
        selected: this.default
      },
      routeTimeOut: null
    }
  },

  watch: {
    data: {
      deep: true,
      handler () {
        if (this.first) this.initialize()
        this.first = false
      }
    }
    /* '$route' () {
      clearTimeout(this.routeTimeOut)
      this.routeTimeOut = setTimeout(function () {
        this.initialize()
      }.bind(this), 999)
    } */
  },

  methods: {
    initialize () {
      if ((this.routerPath && this.routerPath.page === this.pageName) && parseInt(this.routerPath.id) > 0) {
        const item = (typeof this.data !== 'undefined' && this.data ? this.data.find(element => element.id === parseInt(this.routerPath.id)) : false)
        if (item) {
          switch (this.routerPath.action) {
            case 'view':
              this.viewDialog(item)
              break
            case 'edit':
              this.editDialog(item)
              break
          }
        } else {
          this.$store.dispatch('snackBar', { type: 1, message: this.lang[this.routerPath.page].messages.error.not_found })
        }
      } else if (this.routerPath && this.routerPath.action === 'new') {
        this.newDialog()
      } else {
        this.resetDialog()
      }
    },

    newDialog () {
      this.dialog.selected = Object.assign({}, { ...this.default })
      this.dialog.view = false
      this.$router.push({
        name: `${this.routerPath.root}${(this.routerPath.page && this.routerPath.page !== 'default' ? ':' + this.routerPath.type : '')}:new`,
        params: {
          page: (this.routerPath.page ? this.routerPath.page_path : false)
        }
      }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
      this.dialog.save = true
    },

    viewDialog (item) {
      this.dialog.selected = item
      this.dialog.save = false
      this.$router.push({
        name: `${this.routerPath.root}${(this.routerPath.page && this.routerPath.page !== 'default' ? ':' + this.routerPath.type : '')}:view`,
        params: {
          id: item.id,
          page: (this.routerPath.page ? this.routerPath.page_path : false)
        }
      }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
      this.dialog.view = true
    },

    editDialog (item) {
      const item_ = Object.entries(item)
      const item__ = {}
      item_.forEach((value_, key_) => {
        key_ = value_[0]
        value_ = value_[1]
        const blank_ = []
        item__[key_] = (value_ && value_.constructor.name === 'Array' ? blank_.concat(value_) : value_)
      })
      this.dialog.selected = Object.assign({}, item__)
      // this.dialog.selected = { ...item }
      this.dialog.view = false
      this.$router.push({
        name: `${this.routerPath.root}${(this.routerPath.page && this.routerPath.page !== 'default' ? ':' + this.routerPath.type : '')}:edit`,
        params: {
          id: item.id,
          page: (this.routerPath.page ? this.routerPath.page_path : false)
        }
      }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
      this.dialog.save = true
    },

    resetDialog () {
      this.dialog.selected = this.default
      this.dialog.view = false
      this.dialog.save = false
    },

    onCloseView (val) {
      if (val) this.$router.push({ name: `${this.routerPath.root}${(this.routerPath.page && this.routerPath.page !== 'default' ? ':' + this.routerPath.type : '')}`, params: { page: (this.routerPath.page ? this.routerPath.page_path : false) } }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
      this.dialog.view = !val
    },

    onCloseSave (val) {
      if (val)
        this.$router.push({
          name: `${this.routerPath.root}${(this.routerPath.page && this.routerPath.page !== 'default' ? ':' + this.routerPath.type : '')}`,
          params: { page: (this.routerPath.page ? this.routerPath.page_path : false) }
        }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
      this.dialog.save = !val
    }
  },

  created () {
    this._onPopState = () => {
      this.initialize()
    }
    window.addEventListener('popstate', this._onPopState)
    this.initialize()
  },

  destroyed () {
    window.removeEventListener('popstate', this._onPopState)
    this._onPopState = null
  }
}

export default listDefaults
